import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

const AddLocationLayer = () => {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const handleCancel = () => {
        navigate(-1); // Go back to the previous page in history
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        // Example: Prepare the payload and call an API
        const payload = {
            name,

        };

        api.post('/location/', payload)
            .then(response => {
                toast.success("Location Added!");
                // Navigate back and pass a state to trigger refresh.  This is key.
                navigate(-1, { state: { refresh: true } });
            })
            .catch(error => {
                toast.error(error.response.data.message || 'An error occurred while adding location.');
            })
            .finally(() => {
                setLoading(false); // Always set loading to false, even on error.
            });

        console.log('Location Data:', payload);
        // Redirect or reset after successful submission -  NOW HANDLED IN .then()
    };

    return (
        <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8 col-lg-10">
                        <div className="card border">
                            <div className="card-body">
                                <h6 className="text-md text-primary-light mb-16">Add Location</h6>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-20">
                                        <label
                                            htmlFor="Name"
                                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                                        >
                                            Name <span className="text-danger-600">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            placeholder="Enter the name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="d-flex align-items-center justify-content-center gap-3">
                                        <button
                                            type="button"
                                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                            disabled={loading}
                                        >
                                            {loading ? <Spinner animation="border" size="sm" /> : 'Save'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddLocationLayer;